import React from "react";
import FooterBg from "assets/images/footerbg.png";
import Pose from "components/animation/hero/Pose";
import { pose1, pose2, pose3 } from "components/animation/hero/path";
export default function Posing() {
  return (
    <div className="container-fluid above-footer-bg position-relative z-index-1 pb-4">
      <div className="container d-flex align-items-end justify-content-center">
        <div className="above-footer-svg d-lg-flex d-grid">
          <div>
            <Pose duration="1" delay="1.6" />
          </div>
          <div className="	d-none d-sm-none d-md-none d-lg-block">
            <Pose duration="1.5" delay="1.5" />
          </div>
          <div className="	d-none d-sm-none d-md-none d-lg-block">
            <Pose duration="1.7" delay="1.7" />
          </div>
        </div>
      </div>
    </div>
  );
}
